import {
    clearKeyword,
    setKeyword,
} from '../reducers';

import {visibilityStateSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../../hooks/useTypedReactRedux';

export const useApplicationsSearch = () => {

    const dispatch = useAppDispatch();


    // FNP-947: the keyword is genuine Redux UI state - it stays here.
    const {keyword} = useAppSelector((state) => visibilityStateSelector(state));

    const handleFilterByKeyword = (keyword: string) => {
        if (keyword !== '') {
            dispatch(setKeyword(keyword));
        } else {
            dispatch(clearKeyword());
        }
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
